import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import TextEditor from "components/TextEditor";
import { getNewsLetterData } from "services/_newsLetter";
import { Checkbox } from "@mui/material";
import { errorToast } from "components/toast";
import { sendEmail } from "services/_newsLetter";
import { successToast } from "components/toast";
import Spinner from "layouts/spinner";
import { useNavigate } from "react-router-dom";

const Sendmail = () => {
  const [subject, setSubject] = useState("");
  const [editorValue, setEditorValue] = useState("");
  const [email, setEmail] = useState([]);
  const [ccAll, setCcAll] = useState(false);
  const [ccEmail, setCcEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const initialData = async () => {
    const data = await getNewsLetterData();
    if (data.isSuccess) {
      const emails = data.data.map((item) => item.email);
      setEmail(emails);
    } else {
      setEmail([]);
    }
  };

  useEffect(() => {
    initialData();
  }, []);

  const handleCheckboxChange = (checked) => {
    setCcAll(checked);
    if (checked) {
      setCcEmail("");
    }
  };

  const handleSendMail = async () => {
    if (!subject || !editorValue) {
      return errorToast("All field are required");
    }
    if (!ccAll && !ccEmail) {
      return errorToast("Please select CC (All Mails or one email)");
    }
    setLoading(true);
    const payload = {
      subject,
      body: editorValue,
      ccAll,
      email: ccEmail,
    };

    const data = await sendEmail(payload);
    if (data.isSuccess) {
      successToast(data.message);
      setLoading(false);
    } else {
      errorToast(data.message);
    }
  };

  const handleNavigate = () => {
    navigate("/admin/newsletter");
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              {loading && <Spinner isFullScreen={true} />}
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <i
                    className="fas fa-arrow-left"
                    style={{ paddingRight: "10px" }}
                    onClick={handleNavigate}
                  ></i>
                  <h3 className="mb-0">Send Mail</h3>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <div className="pl-lg-4">
                    {/* Subject */}
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label">
                            Subject <span style={{ color: "red" }}>*</span>
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            placeholder="Enter subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <label className="form-control-label">
                            CC <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="d-flex align-items-center">
                            <Checkbox
                              checked={ccAll}
                              onChange={(e) =>
                                handleCheckboxChange(e.target.checked)
                              }
                              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                            />
                            <p style={{ margin: 0 }}>Select All</p>
                          </div>
                          {!ccAll && (
                            <Input
                              type="select"
                              value={ccEmail}
                              disabled={ccAll}
                              onChange={(e) => setCcEmail(e.target.value)}
                            >
                              <option value="">Select email</option>
                              {email.map((em, idx) => (
                                <option key={idx} value={em}>
                                  {em}
                                </option>
                              ))}
                            </Input>
                          )}
                          {/* </div> */}
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Body */}
                    <Row>
                      <Col lg="12" style={{ marginBottom: "40px" }}>
                        <label className="form-control-label">Body</label>
                        <div className="custom-quill">
                          <TextEditor
                            value={editorValue}
                            onChange={setEditorValue}
                            placeholder="Write mail body here..."
                            height={400}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Send Button */}
                  <div className="pl-lg-4">
                    <Button color="primary" onClick={handleSendMail}>
                      Send Mail
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Sendmail;
